/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offer_Tab_ServicesInputs */

const en_offer_tab_services = /** @type {(inputs: Offer_Tab_ServicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Services`)
};

const pl_offer_tab_services = /** @type {(inputs: Offer_Tab_ServicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usługi`)
};

/**
* | output |
* | --- |
* | "Services" |
*
* @param {Offer_Tab_ServicesInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const offer_tab_services = /** @type {((inputs?: Offer_Tab_ServicesInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offer_Tab_ServicesInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_offer_tab_services(inputs)
	return en_offer_tab_services(inputs)
});